export default __webpack_public_path__ + "static/media/Variations.30a0bc77.svg";